var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Close"),React.createElement("path",{"d":"M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z","key":1})]);
}

Close.defaultProps = {"viewBox":"0 0 400 400"};

module.exports = Close;

Close.default = Close;
